import { Component, ViewChild, Input, OnInit, ViewChildren, QueryList } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { BsDatepickerConfig, BsDatepickerDirective, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { messageService } from 'src/app/message.service';

type from = 'Master' | 'Details' | 'Dependency';

@Component({
  selector: 'app-flexible-fields',
  templateUrl: './flexible-fields.component.html',
  styleUrls: ['./flexible-fields.component.scss']
})

export class FlexibleFieldsComponent implements OnInit {

  @Input() from: from;
  @Input() dependency: any;
  requestedAt: any;

  public dateCustomClasses: DatepickerDateCustomClasses[];
  public dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  isProcessing: boolean = false;
  flexibleFieldsList: any = [];
  flexibleFields: any = [];
  statusSeq: any = null;
  dropDownSearchText: string = '';

  constructor(
    public readonly qualityService: qmsService,
    private readonly appService: AppService,
    private readonly message: messageService,
    private readonly snackBar: MatSnackBar,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  public readonly $commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  public $getDateConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null;
    let maxDate: Date | null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();

    } else if (lov == "Future Date") {
      minDate = new Date();
      maxDate = null;

    } else if (lov == "Past Date") {
      minDate = null;
      maxDate = new Date();

      /* Current Date + n days */
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));

      /* Current Date - n days */
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();

    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat,
      minDate: minDate!,
      maxDate: maxDate!
    };
  }

  public $getDateTimeConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null;
    let maxDate: Date | null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();

    } else if (lov == "Future Date") {
      minDate = new Date();
      maxDate = null;

    } else if (lov == "Past Date") {
      minDate = null;
      maxDate = new Date();

      /* Current Date + n days */
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));

      /* Current Date - n days */
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();

    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat + ' HH:mm:ss',
      minDate: minDate!,
      maxDate: maxDate!,
      withTimepicker: true,
    };
  }

  public focusSearch(value: any): void {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus() }, 0)
  }

  @ViewChild('datePicker', { static: false }) datepicker!: BsDatepickerDirective;
  public onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => { datepicker.show(); }, 0);
  }

  @ViewChildren('multiselect') multiselect!: QueryList<MatSelect>;
  multiSelection: boolean = false;

  public toggleAllSelection(value: any, field: any, id: any): void {
    if (value === 'multiselect') {
      const targetSelect = this.multiselect.find((select: MatSelect) =>
        select._elementRef.nativeElement.dataset.fieldId == field.fieldLovValues
      );

      if (targetSelect) {
        if (field.multiSelection) {
          targetSelect.options.forEach((item: MatOption) => item.select());
        } else {
          targetSelect.options.forEach((item: MatOption) => item.deselect());
          field.dd = [];
        }
      }
      setTimeout(() => this.from == 'Details' && field.isMandatory == 'Y' && this.handleMultiValidation(id, field))
    }
  }

  onMultiSelect(event: any, field: any, id: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        field.multiSelection = field.fieldLovValues.length == field.dd.length;
        this.from == 'Details' && this.handleMultiValidation(id, field);
      })
    }
  }

  onDropdownSelect(event: any, field: any, id: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.from == 'Details' && this.handleSingleValidation(id, field); })
    }
  }

  onCheckboxChange(event: any, value: string, field: any): void {
    if (event.checked) {
      field.dd.push(value);
    } else {
      let index = field.dd.indexOf(value);
      field.dd.splice(index, 1)
    }
  }

  flexibleGroup: any;
  flexibleModule: string;
  flexibleStatus: any;

  ngOnInit() {

    if (this.from == 'Master') {
      this.flexibleGroup = this.qualityService.selectedGroup;
      this.flexibleModule = this.qualityService.moduleName;
      this.flexibleStatus = null;
    } else if (this.from == 'Dependency') {
      this.flexibleGroup = this.dependency.groupId;
      this.flexibleModule = this.dependency.module;
      this.flexibleStatus = null;
    } else {
      this.flexibleGroup = this.qualityService.selectedGroup;
      this.flexibleModule = this.qualityService.moduleName;
      this.flexibleStatus = this.qualityService.activity.status;
    }

    if (this.from != 'Details') this.main();
  }

  public main(): void {
    if (!this.flexibleGroup) return;

    if (this.from == 'Details') {
      this.flexibleGroup = this.qualityService.selectedGroup;
      this.flexibleModule = this.qualityService.moduleName;
      this.flexibleStatus = this.qualityService.activity.status;
    }
    const obj = { groupId: this.flexibleGroup, module: this.flexibleModule, status: this.flexibleStatus };

    if (this.from == 'Details') {
      this.appService.gettaskStatusSetupByStatus(this.flexibleModule, this.flexibleStatus).subscribe((data1: any) => {
        this.statusSeq = data1.taskSeq;
        this.getFlexibleFields(obj);
      })
    } else {
      this.getFlexibleFields(obj);
    }
  }

  private getFlexibleFields(obj: any): void {
    this.flexibleFieldsList = this.flexibleFields = [];

    this.appService.getQualityFlexibleFieldsList(obj).subscribe((flexibleFields: any) => {
      this.flexibleFieldsList = flexibleFields?.filter((x: any) => x.isActive === "Y");
      if (this.from == 'Master' || this.from == 'Dependency') {
        this.setMasterFields();
      } else if (this.from == 'Details') {
        this.setDetailsFields();
      }
    })
  }

  private setMasterFields(): void {
    const module = this.flexibleModule;
    const x: any[] = this.flexibleFieldsList.filter((x: any) => x.isMandatory == 'Y' && !x.appearFromStatus && x.taskSeq == 0);

    for (let y of x) {
      if (y.allowedBusinessAreas) {
        if (this.requestedAt && module != 'AU' && module != 'CC' && module != 'OOS') {
          const areas: any[] = y.allowedBusinessAreas?.split(',') ?? [];
          if (areas.includes(this.requestedAt)) {
            this.setDefaultValue(y);
            this.masterPush(y);
          }
        }
      } else if (!y.allowedBusinessAreas) {
        this.setDefaultValue(y);
        this.masterPush(y);
      }
    }
    this.designUI();
  }

  private setDefaultValue(field: any): void {

    this.normalizeField(field);

    if (field.fieldDefaultValue &&
      (field.fieldType === 'Multiselect Drop Down' || field.fieldType === 'Vertical Checkbox Button' || field.fieldType === 'Horizontal Checkbox Button')
    ) {
      field.dd = field.fieldDefaultValue.split(',').map((y: string) => y.trim());
    } else if (!field.fieldDefaultValue &&
      (field.fieldType === 'Multiselect Drop Down' || field.fieldType === 'Vertical Checkbox Button' || field.fieldType === 'Horizontal Checkbox Button')) {
      field.dd = [];
    }
  }

  private normalizeField(field: any) {
    if (typeof field.fieldLovValues === 'string') {
      field.fieldLovValues = field.fieldLovValues.split(',').map((v: string) => v.trim());
    }
  }

  private masterRemove(y: any): void {
    const index = this.flexibleFields.findIndex((f: any) => !f.allowedBusinessAreas.includes(this.requestedAt));

    if (index !== -1) {
      const y = this.flexibleFields[index];

      if (y.fieldType === 'Multiselect Drop Down' || y.fieldType === 'Vertical Checkbox Button' || y.fieldType === 'Horizontal Checkbox Button') {
        y.dd = [];
      } else {
        y.fieldDefaultValue = null;
      }

      this.flexibleFields.splice(index, 1);
    }
  }


  private masterPush(y: any) {
    const x: any = this.flexibleFields.find((f: any) => f.fieldName == y.fieldName)
    if (!x) this.flexibleFields.push(y);
    console.log("Field push", y);
  }

  private setDetailsFields() {
    const module = this.flexibleModule;

    for (let element of this.flexibleFieldsList) {

      element.currentStatusField = false;
      element.fieldAlreadyDisplayed = false;

      if (element.appearFromStatus) {
        if (element.taskSeq == this.statusSeq) {
          element.currentStatusField = true;
          this.setNext(element, module);
        } else if (element.taskSeq < this.statusSeq) {
          element.fieldAlreadyDisplayed = true;
          this.setNext(element, module);
        }
      } else {
        this.setNext(element, module);
      }
    }
    this.designUI();
  }

  private removeInvalidBusinessArea() {

    for (let i = this.flexibleFields.length - 1; i >= 0; i--) {
      const y = this.flexibleFields[i];
      const areas = y.allowedBusinessAreas?.split(',') ?? [];

      if (!areas.includes(this.requestedAt) && y.allowedBusinessAreas) {
        if (y.fieldType === 'Multiselect Drop Down' || y.fieldType === 'Vertical Checkbox Button' || y.fieldType === 'Horizontal Checkbox Button') {
          y.dd = [];
        } else {
          y.fieldDefaultValue = null;
        }
        this.flexibleFields.splice(i, 1);
      }
    }
  }

  private setNext(element: any, module: any): void {
    const requestedAtVariableMapping: Record<string, any> = {
      'CR': this.qualityService.crPageAllDropdownValues.requestedAtValue, 'CAPA': this.qualityService.capaPageAllDropdownValues.requestedAtValue,
      'DV': this.qualityService.dvPageAllDropdownValues.requestedAtValue, 'IN': this.qualityService.incidentDropDowns.selectedRequestedAt,
      'QI': this.qualityService.qiDropDowns.selectedQiRequestedAt,
    };

    if (element.allowedBusinessAreas && module != 'AU' && module != 'CC' && module != 'OOS') {
      const areas: any[] = element.allowedBusinessAreas?.split(',');
      if (areas.includes(requestedAtVariableMapping[module])) {
        this.setDefaultValue(element);
        this.flexibleFields.push(element);
      }
    } else {
      this.setDefaultValue(element);
      this.flexibleFields.push(element);
    }
  }

  private designUI(): void {
    for (let field of this.flexibleFields) {

      if (field.fieldLovValues && !Array.isArray(field.fieldLovValues)) {
        if (field.fieldDatatype == 'Number') {
          field.fieldLovValues = field.fieldLovValues.split(',').map(Number);
        } else {
          field.fieldLovValues = field.fieldLovValues.split(',');
        }
      }
    }

    this.from == 'Details' && this.getFieldValues();
  }

  flexibleFieldsObj: any = [];
  private getFieldValues(): void {
    this.appService.getQualityFlexibleFieldsValue(this.qualityService.activityId).subscribe((values: any) => {
      if (!values.length) return;

      this.flexibleFieldsObj = values[0];

      for (let field of this.flexibleFields) {

        if (field.mappingColumn) {
          const variable = this.makeVariable(field);

          if (values[0][variable]) {
            field.recordId = values[0].recordId;

            if (field.fieldDatatype == 'Date' || field.fieldDatatype == 'Datetime') {
              field.fieldDefaultValue = new Date(values[0][variable]);

            } else if (field.fieldType == 'Multiselect Drop Down' || field.fieldType == 'Vertical Checkbox Button' || field.fieldType == 'Horizontal Checkbox Button') {
              field.dd = values[0][variable].split(',');
              field.multiSelection = field.dd.length == field.fieldLovValues.length;

            } else {
              field.fieldDefaultValue = values[0][variable];
            }
          }
        }
      }
    })
  }

  private makeVariable(data: any): string {
    let splittedData = data.mappingColumn.toLowerCase().split("_");
    for (let j = 1; j < splittedData.length; j++) {
      splittedData[j] = splittedData[j].charAt(0).toUpperCase() + splittedData[j].slice(1);
    }
    return splittedData.join('');
  }

  public triggerFromRequestedAt(area: any): void {
    this.requestedAt = area;
    if (this.flexibleFields.length) { this.removeInvalidBusinessArea(); }
    if (this.from == 'Details') { this.setDetailsFields(); }
    else this.setMasterFields();
  }

  public handleSingleValidation(fieldId: string, item: any): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    if (field) {
      if (item.fieldDefaultValue) {
        field.style.color = '#005c8a'
      } else if (!item.fieldDefaultValue && item.isMandatory == 'Y') {
        field.style.color = 'red'
      }
    } else {
      console.warn('Unable to find the element. Id → ', fieldId);
    }
  }

  public handleMultiValidation(fieldId: string, items: any): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    if (field) {
      if (items.dd.length) {
        field.style.color = '#005c8a'
      } else if (!items.dd.length && items.isMandatory == 'Y') {
        field.style.color = 'red'
      }
    } else {
      console.warn('Unable to find the element. Id → ', fieldId);
    }
  }

  public onNgModelChange(items: any, fieldId: string): void {
    if (this.from == 'Master') return;
    if (items.isMandatory != 'Y') return;

    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items.fieldDefaultValue ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  public mandatoryValidation(): boolean {
    if (this.from !== 'Details') return false;

    let hasErrors = false;

    for (let i = 0; i < this.flexibleFields.length; i++) {
      const field = this.flexibleFields[i];
      const element = document.getElementById(String(i)) as HTMLElement;

      if (field.isMandatory === 'Y') {
        const isMulti = field.fieldType === 'Multiselect Drop Down' || field.fieldType === 'Vertical Checkbox Button' || field.fieldType === 'Horizontal Checkbox Button';

        if (isMulti) {
          if (!field.dd?.length) {
            if (element) element.style.color = 'red';
            hasErrors = true;
          }
        } else if (!isMulti) {
          if (!field.fieldDefaultValue) {
            if (element) element.style.color = 'red';
            hasErrors = true;
          }
        }
      }
    }

    return hasErrors;
  }


  public save(from: string, refNo: number): void {
    const isMandatoryPending: boolean = this.from == 'Details' && this.mandatoryValidation();

    if (isMandatoryPending) {
      setTimeout(() => this.showSnackBar('Please enter all mandatory fields !', 'E'))
    } else {
      let obj: any = {

        refId: refNo,
        version: 0,
      }

      for (let field of this.flexibleFields) {
        if (field.mappingColumn) {
          const variable = this.makeVariable(field);
          if (field.fieldType == 'Horizontal Checkbox Button' || field.fieldType == 'Vertical Checkbox Button' || field.fieldType == 'Multiselect Drop Down') {
            field.fieldDefaultValue = field.dd.join(',');
          }

          obj[variable] = field.fieldDefaultValue;
          obj.recordId = field.recordId;
          this.from == 'Details' && (obj.appearFromStatusInitiated = field.appearFromStatusInitiated);
        }
      }

      if (this.from == 'Master' || this.from == 'Dependency') {
        this.appService.addFlexifieldData(obj).subscribe((response: any) => {
          if (response.resultType == "E") {
            this.showSnackBar(response.result, 'E');
          } else if (from == 'flexible') {
            this.showSnackBar(response.result, 'S');
          }
        })
      } else {
        this.appService.updateFlexifieldData(obj).subscribe((response: any) => {
          if (response.resultType == "E") {
            this.showSnackBar(response.result, 'E');
          } else if (from == 'flexible') {
            this.showSnackBar(response.result, 'S');
          }
        })
      }
    }
  }

  public getDisabled(field: any): boolean {
    return this.qualityService.activity.status == 'Closed';
  }

  snackbarRef: any;
  private showSnackBar(message: string, type: string): void {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

}

